/*
 * DasboardFilters Messages
 *
 * This contains all the text for the DasboardFilters component.
 */
import { defineMessages } from 'react-intl';
import { DASHBOARD } from '@config/modelsConfig';

const messages = {
  byOrganizationName: {
    id: 'ORGANIZATIONS_FILTER.byOrganizationName',
    defaultMessage: 'By name',
  },
  filter: {
    id: 'ORGANIZATIONS_FILTER.filter',
    defaultMessage: 'Filter',
  },
};

export default defineMessages(messages);



// WEBPACK FOOTER //
// ./components/molecules/OrganizationFilters/messages.js